const DEFAULT_SUPPORT_ROLLOUT = {
  enabled: true,
  rolloutStage: "targeted",
  supportPageEnabled: true,
  accountEntryEnabled: true,
  receiptEntryEnabled: true,
  postCheckoutEntryEnabled: false,
  floatingWidgetEnabled: false,
};

const normalizeBoolean = (value, fallback = false) =>
  value === undefined ? fallback : Boolean(value);

export const normalizeSupportRolloutConfig = (value = {}) => ({
  enabled: normalizeBoolean(value?.enabled, DEFAULT_SUPPORT_ROLLOUT.enabled),
  rolloutStage: String(value?.rolloutStage || DEFAULT_SUPPORT_ROLLOUT.rolloutStage).trim() || DEFAULT_SUPPORT_ROLLOUT.rolloutStage,
  supportPageEnabled: normalizeBoolean(value?.supportPageEnabled, DEFAULT_SUPPORT_ROLLOUT.supportPageEnabled),
  accountEntryEnabled: normalizeBoolean(value?.accountEntryEnabled, DEFAULT_SUPPORT_ROLLOUT.accountEntryEnabled),
  receiptEntryEnabled: normalizeBoolean(value?.receiptEntryEnabled, DEFAULT_SUPPORT_ROLLOUT.receiptEntryEnabled),
  postCheckoutEntryEnabled: normalizeBoolean(value?.postCheckoutEntryEnabled, DEFAULT_SUPPORT_ROLLOUT.postCheckoutEntryEnabled),
  floatingWidgetEnabled: normalizeBoolean(value?.floatingWidgetEnabled, DEFAULT_SUPPORT_ROLLOUT.floatingWidgetEnabled),
});

export const isSupportEntryEnabled = (rolloutConfig = DEFAULT_SUPPORT_ROLLOUT, sourceContext = "") => {
  const rollout = normalizeSupportRolloutConfig(rolloutConfig);
  if (!rollout.enabled) return false;

  const source = String(sourceContext || "").trim();
  if (!source || source === "support_page") return rollout.supportPageEnabled;
  if (source === "floating_widget") return rollout.floatingWidgetEnabled;
  if (source === "concierge_handoff") return rollout.floatingWidgetEnabled;
  if (["account_queries", "account_bookings", "booking_card"].includes(source)) {
    return rollout.accountEntryEnabled;
  }
  if (source === "account_receipt") return rollout.receiptEntryEnabled;
  if (["payment_page", "booking_result"].includes(source)) return rollout.postCheckoutEntryEnabled;
  if (["admin_hub", "admin_quick_create", "system", "email_webhook"].includes(source)) return true;
  return rollout.supportPageEnabled;
};

export { DEFAULT_SUPPORT_ROLLOUT };
